<template>
  <div style="width: 100%">
    <div id="bgImage" class="index"></div>
    <el-container class="blogList">
      <el-header class="header">

        <el-row :gutter="20">
          <el-col :span="8" style="cursor: pointer;width: max-content;padding: 0;margin-left: 20px">
            <h2 id="logo"> 时 光</h2>
          </el-col>
          <el-col :span="16">
            <el-menu style="border: none;display: flex;margin-left: 100px;left: 0" active-text-color="#ffd04b"
                     background-color="rgba(0, 0, 0, 0)"
                     class="menu"
                     mode="horizontal"
                     :default-active="items[0].path"
                     router
                     text-color="#fff">
              <el-menu-item class="menu_item" :key="item.id" :index="item.path" v-for="item in items">
                <template slot="title">
                  <!--                图标-->
                  <i :class="[item.icon]"></i>
                  <!--                文本-->
                  <span style="margin-left: 5px">{{ item.title }}</span>
                </template>
              </el-menu-item>
            </el-menu>
          </el-col>

        </el-row>
        <div style="display: flex;margin: 0 40px 0 170px;">
          <el-autocomplete class="search"
                           v-model="input"
                           prefix-icon="el-icon-search"
                           :fetch-suggestions="querySearchAsync"
                           @select="handleSelect"
                           placeholder="请输入内容"
                           size="small"
          ></el-autocomplete>
        </div>

        <div id="logined" class="logined">
          <img id="head" class="image" :src="loginInfo.headPortrait">
          <div id="user-option" class="user-option">
            <h4 style="margin-top: 28px;">{{ loginInfo.name }}</h4>
            <p @click="logout()" style="font-size: 16px;padding-top: 5px;padding-bottom: 5px">退出登录</p>
          </div>
        </div>
        <div v-show="!loginInfo.isLogin" style="display: flex;margin: 0 30px 0 auto;">
          <el-button size="mini" effect="light" type="primary" @click="loginBtn">登录</el-button>
          <el-button size="mini" effect="light" type="warning" @click="registerBtn">注册</el-button>
        </div>
      </el-header>
    </el-container>

    <!--登录    -->
    <el-dialog id="login" class="login-dialog" title="登 录" width="480px" :visible.sync="loginDialogVisible"
               :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="false"
               @close="onLoginClose('loginRuleForm')" center top="14%">
      <el-form :model="loginForm" status-icon :rules="loginRules" ref="loginRuleForm" label-width="120px"
               class="demo-ruleForm">
        <el-form-item label="账 号：" prop="account">
          <el-input v-model="loginForm.account" autocomplete="off" placeholder="由数字组成" type="text" size="medium"
                    style="width: 260px"
                    maxlength="11"
                    show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="密 码：" prop="password">
          <el-input v-model="loginForm.password" autocomplete="off" placeholder="字母数字下划线(最多16位)" type="text"
                    size="medium"
                    style="width: 260px"
                    show-password></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="inputCode" :rules="{required: true, message: '验证码不能为空', trigger: 'blur'}">
          <div style="display: flex">
            <el-input v-model="loginForm.inputCode" placeholder="不区分大小写" type="text" size="medium"
                      style="width: 160px" maxlength="4"
                      show-word-limit></el-input>
            <el-image :src="loginForm.imgUrl"
                      style="width: 89px;height: 40px;margin-left: 10px;margin-top: 1px;cursor: pointer"
                      title="点击换一张"
                      @click="changeCode"></el-image>
          </div>
          <!--          <img src="" width="30px" height="30px">-->
        </el-form-item>
        <el-form-item>
          <el-button size="small"
                     type="primary" :loading="loginLoading" @click="loginSubmit('loginRuleForm')">登录
          </el-button>
          <el-button size="small" @click="loginCancel('loginRuleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!--注册    -->
    <el-dialog class="login-dialog" title="注 册" width="480px" :visible.sync="registerDialogVisible"
               :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="false"
               @close="onRegisterClose('registerRules')" centerp center top="2%">
      <el-form :model="registerForm" status-icon :rules="registerRules" ref="registerRules" label-width="100px"
               class="demo-ruleForm"
               style="margin-left: 20px">
        <el-form-item label="头像：" prop="headPortrait"
                      :rules="{required: true, message: '头像不能为空', trigger: 'blur'}">
          <el-upload
            v-model="registerForm.headPortrait"
            class="avatar-uploader"
            :action="uploadActionUrl+'/uploadImage'"
            name="image"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess">
            <img v-if="registerForm.headPortrait" :src="registerForm.headPortrait" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="昵称：" prop="name">
          <el-input v-model="registerForm.name" placeholder="由汉字或字母数字组成" maxlength="10"
                    show-word-limit type="text" size="medium" style="width: 240px" autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="登录账号：" prop="account">
          <el-input v-model="registerForm.account" placeholder="由数字组成" type="text" size="medium" style="width: 240px"
                    maxlength="11"
                    show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="登录密码：" prop="password">
          <el-input v-model="registerForm.password" placeholder="字母数字下划线" type="text" size="medium" style="width: 240px"
                    show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="surePassword">
          <el-input v-model="registerForm.surePassword" placeholder="两次密码请保持一致" type="password" size="medium"
                    style="width: 240px"
                    show-password></el-input>
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input v-model="registerForm.email" type="email" placeholder="邮箱地址" size="medium" style="width: 240px"
                    autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" :loading="registerLoading" @click="registerSubmit('registerRules')">
            注册
          </el-button>
          <el-button size="small" @click="registerCancel('registerRules')">重置</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>


    <!--激活    -->
    <el-dialog class="login-dialog" title="激活邮箱" width="480px" :visible.sync="activeDialogVisible"
               :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="false" centerp center
               top="10%">
      <el-form :model="activeForm" ref="registerRules" label-width="100px"
               class="demo-ruleForm"
               style="margin-left: 20px">
        <el-form-item label="邮箱：" prop="email">
          <el-input v-model="activeForm.activeEmail" type="email" readonly placeholder="邮箱地址" size="medium"
                    style="width: 240px"
                    autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-link type="primary" style="margin-left: 140px" target="_blank" href="http://www.apple886.com/html/mail/">
          点击前往邮箱大全
        </el-link>
        <el-form-item>
          <el-button size="small" type="primary" style="margin-left: 60px" center
                     @click="activeSubmit(activeForm.activeAccount)">
            已激活
          </el-button>
        </el-form-item>
      </el-form>

    </el-dialog>

  </div>
</template>

<script>

import request from "../../utils/axiosUtils";
import base_url from "../../utils/Constants";

export default {
  name: 'NavBar',
  data() {
    //登录的账号
    let accountValidate = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error("账号不能为空"))
      }
      let accountCheck = /^[0-9]{1,11}$/;
      if (!accountCheck.test(value)) {
        return callback(new Error('账号只能为数字'));
      }
      callback();
    };
    //登录的密码
    let passwordValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'));
      }
      let accountCheck = /^[A-Za-z0-9]{1,16}$/;
      if (!accountCheck.test(value)) {
        return callback(new Error('密码只能为字母或数字(最多16位)'));
      }
      callback();
    };
    //登录的验证码
    let codeValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'));
      }
      let codeCheck = /^[A-Za-z]{6}$/;
      if (!codeCheck.test(value)) {
        return callback(new Error('密码只能为字母或数字(最多16位)'));
      }
      callback();
    };
    //注册的昵称
    let registerNameValidate = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error("昵称不能为空"))
      }
      let nameCheck = /^[\u2E80-\u9FFFa-zA-Z0-9]{1,10}$/;
      if (!nameCheck.test(value)) {
        return callback(new Error('昵称格式有误(由汉字,字母,数字)'));
      }
      callback()
    };
    //注册登录账号
    let registerAccountValidate = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error("账号不能为空"))
      }
      let accountCheck = /^[0-9]{1,11}$/;
      if (!accountCheck.test(value)) {
        return callback(new Error('账号只能为数字'));
      } else {
        this.activeForm.activeAccount = value;
      }
      callback();
    };
    //注册的登录密码
    let registerPasswordValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'));
      }
      let accountCheck = /^[A-Za-z0-9]{1,16}$/;
      if (!accountCheck.test(value)) {
        return callback(new Error('密码只能为字母或数字(最多16位)'));
      }
      callback();
    };
    //注册的登录确定密码
    let registerSurePasswordValidate = (rule, value, callback) => {
      if (value !== this.registerForm.password || !value) {
        return callback(new Error('两次输入的密码不一致'));
      }
      callback();
    };
    //注册的邮箱
    let registerEmailValidate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      } else {
        let emailCheck = /^([a-z0-9_.-]+)@([\da-z.-]+)\.([a-z.]{2,6})$/;
        if (!emailCheck.test(value)) {
          return callback(new Error('邮箱格式有误'));
        } else {
          this.activeForm.activeEmail = value;
        }
      }
      callback()
    };
    return {
      fullscreenLoading: false,
      //登录按钮的动画
      loginLoading: false,
      //注册按钮的动画
      registerLoading: false,
      items: [
        {
          id: 1,
          path: '/home',
          title: '首页',
          icon: "icon-wxbzhuye iconfont"
        },
        {
          id: 2,
          path: '/notes',
          title: '笔记',
          icon: "icon-biji iconfont"
        },
        {
          id: 3,
          path: '/project',
          title: '项目',
          icon: "icon-xiangmu iconfont"
        },
        {
          id: 4,
          path: '/leaveMsg',
          title: '留言',
          icon: "icon-liuyan iconfont"
        },
        {
          id: 5,
          path: '/aboutMe',
          title: '关于我',
          icon: "icon-guanyuwomen iconfont"
        },
      ],
      //输入框内容
      input: "",
      formLabelWidth: "200",
      loginDialogVisible: false,
      loginForm: {
        account: '',
        password: '',
        inputCode: '',
        targetCode: '',
        imgUrl: '',
        recentLoginAddress: ''
      },
      loginInfo: {
        isLogin: false,
        name: '',
        headPortrait: '',
      },
      registerForm: {
        headPortrait: '',
        name: '',
        account: '',
        password: '',
        surePassword: '',
        email: '',
        recentLoginAddress: ''
      },
      loginRules: {
        account: [
          {required: true, validator: accountValidate, trigger: 'blur'}
        ],
        password: [
          {required: true, validator: passwordValidate, trigger: 'blur'}
        ],
        code: [
          {required: true, validator: codeValidate, trigger: 'blur'}
        ]
      },
      registerDialogVisible: false,
      activeDialogVisible: false,
      activeForm: {
        activeEmail: null,
        activeAccount: null,
      },
      registerRules: {
        name: [
          {required: true, validator: registerNameValidate, trigger: 'blur'}
        ],
        account: [
          {required: true, validator: registerAccountValidate, trigger: 'blur'}
        ],
        password: [
          {required: true, validator: registerPasswordValidate, trigger: 'blur'}
        ],
        surePassword: [
          {required: true, validator: registerSurePasswordValidate, trigger: 'blur'}
        ],
        email: [
          {required: true, validator: registerEmailValidate, trigger: 'blur'}
        ],
      },
      blog: [
        {
          id: '',
          value: ''
        }
      ],
      //图片上传路径
      uploadActionUrl: base_url
    }
  },
  methods: {
    //处理输入框的搜索
    querySearchAsync(queryString, cb) {
      // console.log(queryString)
      // var restaurants = this.restaurants;
      //   cb(results);
      if (queryString !== '')
        request({
          url: '/blog/searchBlog/' + queryString,
          method: 'get'
        }).then(response => {
          let data = response.data.data;
          this.blog = data;
          for (let i = 0; i < this.blog.length; i++) {
            this.blog[i].value = data[i].title;
          }
          if (this.blog.length > 0) {
            let result = queryString ? this.blog.filter(this.createStateFilter(queryString)) : this.blog;
            cb(result);
          }
        });
    },
    //处理输入框的搜索
    createStateFilter(queryString) {
      return (item) => {
        return item.value.toUpperCase().match(queryString.toUpperCase());
      };
    },
    //处理输入框的item点击事件,跳转到对应页面
    handleSelect(item) {
      this.$router.push({
        name: "ArticleContent",
        path: '/articleContent',
        params: {
          blogId: item.id,
        }
      })
    },
    //登录按钮的点击事件
    loginBtn() {
      this.loginDialogVisible = true;
      this.changeCode();
    },
    registerBtn() {
      this.registerDialogVisible = true;
    },
    loginCancel(formName) {
      this.$refs[formName].resetFields();
    },
    onLoginClose(formName) {
      this.$refs[formName].resetFields();
      this.loginForm.account = '';
      this.loginForm.password = '';
    },
    onRegisterClose(formName) {
      this.$refs[formName].resetFields();
    },
    //登录按钮提交,axios请求
    loginSubmit(formName) {
      let that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginLoading = true
          /*let url = '6Y4BZ-OE566-BSFSF-MDC6K-YY7L5-DIBM6'
          axios({
            url: 'https://apis.map.qq.com/ws/location/v1/ip',
            method: 'get',
            params: {
              key: url,
              output: 'json'
            }
          }).then(response => {
            console.log(response)
            let location = response.data.result.location;
            let lat = location.lat;
            let lng = location.lng;
            axios({
              url: 'https://apis.map.qq.com/ws/geocoder/v1',
              method: 'get',
              params: {
                key: url,
                location: lat + ',' + lng,
                output: 'json'
              }
            }).then(response => {
              // console.log(response.data.result.address)
              this.loginForm.recentLoginAddress = response.data.result.address;

            }).catch(e => {
              this.loginLoading = false;
              this.$notify({
                title: '登录',
                type: 'error',
                message: '网络错误',
                duration: 3000
              });
            })
          }).catch(e => {
            this.loginLoading = false;
            this.$notify({
              title: '登录',
              type: 'error',
              message: '网络错误',
              duration: 3000
            });
          })*/
          let loginForm = this.loginForm;
          let inputCode = loginForm.inputCode;
          if (inputCode.toUpperCase() !== loginForm.targetCode.toUpperCase()) {
            this.$notify({
              title: '登录失败',
              type: 'error',
              message: '验证码错误',
              duration: 3000
            });
            this.loginLoading = false;
          } else {
            request({
              url: '/user/login',
              method: 'post',
              params: {
                loginInfo: loginForm,
              }
            }).then(response => {
              // console.log(response)
              let flag = response.data.flag;
              if (flag) {
                this.loginLoading = false;
                if (response.data.data.isActive !== 1) {
                  this.$notify.error({
                    title: '账号',
                    duration: 2000,
                    message: "账号未激活，请先去邮箱激活账号",
                  });
                } else {
                  let data = response.data.data;
                  window.localStorage.setItem("isLogin", flag);
                  window.localStorage.setItem("userId", data.id);
                  window.localStorage.setItem("name", data.name);
                  window.localStorage.setItem("headPortrait", data.headPortrait);
                  this.$notify({
                    title: '登录成功',
                    type: 'success',
                    duration: 1500
                  });
                  //重新加载网页
                  location.reload()
                }
              } else {
                this.loginLoading = false;
                this.$notify({
                  title: '登录失败',
                  type: 'error',
                  message: '账号或者密码错误',
                  duration: 3000
                });
              }
            }).catch(e => {
              this.loginLoading = false;
              this.$notify({
                title: '登录',
                type: 'error',
                message: '网络错误',
                duration: 3000
              });
            });
          }
        }
      });
    },
    //处理头像之前
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else if (isPng) {
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
          return false;
        }
        return true;
      } else {
        this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
        return false;
      }
    },
    //处理头像成功
    handleAvatarSuccess(result) {
      // console.log(result)
      if (result.flag) {
        this.registerForm.headPortrait = result.data;
      } else {
        this.$notify.error({
          title: '图片错误',
          duration: 3000,
          message: result.message
        });
      }
    },
    //注册的点击事件
    registerSubmit(formName) {
      let that = this;
      this.registerLoading = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          /*let url = '6Y4BZ-OE566-BSFSF-MDC6K-YY7L5-DIBM6'
          axios({
            url: 'https://apis.map.qq.com/ws/location/v1/ip',
            method: 'get',
            params: {
              key: url,
              output: 'json'
            }
          }).then(response => {
            let location = response.data.result.location;
            let lat = location.lat;
            let lng = location.lng;
            axios({
              url: 'https://apis.map.qq.com/ws/geocoder/v1',
              method: 'get',
              params: {
                key: url,
                location: lat + ',' + lng,
                output: 'json'
              }
            }).then(response => {
              this.registerForm.recentLoginAddress = response.data.result.address;

            }).catch(e => {
              this.registerLoading = false;
              this.$notify.error({
                title: '失败',
                duration: 2000,
                message: "网络错误",
              });
            })
          }).catch(e => {
            this.registerLoading = false;
            this.$notify.error({
              title: '失败',
              duration: 2000,
              message: "网络错误",
            });
          })*/
          request({
            url: '/user/register',
            method: 'post',
            params: {
              registerInfo: that.registerForm
            }
          }).then(response => {
            this.registerLoading = false;
            if (response.data.flag) {
              that.registerDialogVisible = false;
              that.activeDialogVisible = true;
              that.sendEmail(that.activeForm.activeAccount, that.activeForm.activeEmail);
              this.$notify({
                title: '邮箱',
                message: '消息已经发送到您的邮箱,请注意查收',
                duration: 3000,
                type: 'success'
              })
            } else {
              this.$notify.error({
                title: '失败',
                duration: 2000,
                message: response.data.message,
              });
            }
          }).catch(e => {
            this.registerLoading = false;
            this.$notify.error({
              title: '失败',
              duration: 2000,
              message: "网络错误",
            });
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: '请输入正确的值'
          });
          this.registerLoading = false;
          return false;
        }
      });

    },
    //取消注册
    registerCancel(formName) {
      this.$refs[formName].resetFields();
    },
    //登出
    logout() {
      window.localStorage.clear()
      location.reload()
    },
    //刷新验证码
    changeCode() {
      request({
        url: '/Leave/code',
        method: 'post',
      }).then(response => {
        this.loginForm.targetCode = response.data.code;
        this.loginForm.imgUrl = 'data:image/png;base64,' + response.data.photo;
      })
    },
    //实现发送邮件
    sendEmail(account, email) {
      request({
        url: 'Leave/send',
        params: {
          account: account,
          email: email
        },
        method: 'post',
      })
    },
    //已激活按钮
    activeSubmit(account) {
      let that = this;
      request({
        url: "Leave/findActive",
        params: {
          account: account
        },
        method: "post"
      }).then(response => {
        if (response.data.flag) {
          this.$notify.success({
            title: '账号',
            duration: 2000,
            message: '激活成功',
          });
          that.activeDialogVisible = false;
        } else {
          this.$notify.error({
            title: '账号',
            duration: 2000,
            message: '激活失败，请先激活',
          });
        }
      })
    },
    //设置登录后的动画效果
    loginedAnimation() {
      let isLogin = window.localStorage.getItem("isLogin");
      if (isLogin) {
        let logined = document.getElementById("logined");
        logined.style.visibility = "visible"
        this.loginInfo.isLogin = isLogin;
        this.loginInfo.name = window.localStorage.getItem("name");
        this.loginInfo.headPortrait = base_url + "/getImage/" + window.localStorage.getItem("headPortrait");
      }
      let head = document.getElementById("head");
      let userOption = document.getElementById("user-option");
      head.onmouseover = function () {
        head.style.transform = "translate(0, 50%) scale(" + 1.3 + ")";
        userOption.style.visibility = "visible"
      }
      head.onmouseleave = function () {
        head.style.transform = "";
        userOption.style.visibility = "hidden"
      }
      userOption.onmouseover = function () {
        head.style.transform = "translate(0, 50%) scale(" + 1.3 + ")";
        userOption.style.visibility = "visible"
      }
      userOption.onmouseleave = function () {
        head.style.transform = "";
        userOption.style.visibility = "hidden"
      }
    },
  },
  mounted() {
    this.loginedAnimation();
    //实现背景图片的随即切换
    let bgImage = document.getElementById("bgImage");
    let random = parseInt(Math.random() * 27) + 1;
    bgImage.style.backgroundImage = "url(" + base_url + "/getStaticImage/bg" + random + ".png)"
  }
}
</script>
<!--单独给el-input设置样式-->
<style>
.search input.el-input__inner {
  background-color: rgba(0, 0, 0, 0.1);
  color: #cccccc;
}

.login-dialog .el-dialog__title {
  font-size: 22px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}

.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
</style>

<style scoped>
.logined {
  visibility: hidden;
  position: relative;
  display: flex;
  margin: 0 30px 0 auto;
  z-index: 9998;
}

.image {
  cursor: pointer;
  transition: all 0.3s;
  z-index: 9999;
  width: 47px;
  height: 47px;
  border-radius: 50%;
}

.image:hover {
  /*transform: translate(0, 50%) scale(1.3);
  transition: .3s;*/
}

.user-option {
  position: absolute;
  top: 54px;
  text-align: center;
  right: -42px;
  background-color: #fff;
  width: 130px;
  color: #333;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, .5);
  border: 1px solid #eee;
  border-radius: 5px;
  cursor: pointer;
  visibility: hidden;
}

.user-option p:hover {
  background-color: #cccccc;
}


.blogList {
  display: flex;
}

.index {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
}

.header {
  width: 100%;
  position: relative;
  font-size: 1.1rem;
  display: flex;
  height: 60px;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.32);
}

#logo {
  color: #ffd04b;
  font-size: 28px;
  line-height: 50%;
}

.menu .menu_item {
  font-size: 16px;
  margin-left: 1px;
  text-align: center;
}

.menu .menu_item:hover {
  background-color: rgba(73, 70, 70, 0.58) !important;
}

.search-input {

  width: 180px;
}

.login-register {
  /*margin: 0 0 0 auto;
  display: flex;*/
}
</style>




// WEBPACK FOOTER //
// src/components/layout/NavBar.vue